exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".appStoreCancelDialog-18253073{display:flex;margin:40px 30px 40px 30px}.phoneImg-89cd47af{flex:0 1 50%;position:relative}.instructions-a6d513c1{flex:1 1 50%;display:flex;align-items:center}\n", ""]);

// Exports
exports.locals = {
	"appStoreCancelDialog": "appStoreCancelDialog-18253073",
	"phoneImg": "phoneImg-89cd47af",
	"instructions": "instructions-a6d513c1"
};